import { errorToHumanString } from './validation';

const namePrefix = 'form_';

export const persistFormData = function(formName, formData) {
  localStorage.setItem(`${namePrefix}${formName}`, JSON.stringify(formData));
};

export const withdrawFormData = function(formName) {
  let formData;
  let storageFormData = localStorage.getItem(`${namePrefix}${formName}`);

  if (storageFormData) {
    formData = JSON.parse(storageFormData);
  } else {
    formData = {};
  }

  return formData;
};

export const clearFormData = function(formName) {
  localStorage.removeItem(`${namePrefix}${formName}`);
};

export const hideAllErrors = function(formData) {
  for (const [key, value] of Object.entries(formData)) {
    value.error = '';
  }
};

export const showErrors = function(formData, errors) {
  let errorString;
  let hasErrors = false;
  hideAllErrors(formData);

  for (const [valueName, error] of Object.entries(errors)) {
    if (formData[valueName]) {
      errorString = errorToHumanString(error.rule, error.param);
      formData[valueName].error = errorString;
      hasErrors = true;
    }
  }

  return hasErrors;
};

export const marshal = function(formData) {
  const marshaled = {};
  for (let [valName, valDef] of Object.entries(formData)) {

    if (valDef.sensitive) {
      continue;
    }

    let val = valDef.val;
    switch (valDef.type) {
      case 'bool':
        val = !!val;
        break;
      default:
    }

    marshaled[valName] = val;
  }
  return marshaled;
};

export const unmarshal = function(rawData, formData) {
  for (var [valName, val] of Object.entries(rawData)) {
    if (formData[valName]) {
      formData[valName].val = val;
    }
  }
};

export const prepareFormData = function(formDataDef, formData, vue) {
  for (var [valName, valDef] of Object.entries(formDataDef)) {
    const val = typeof valDef.val !== 'undefined' ? valDef.val : '';

    vue.$set(formData, valName, {
      valName,
      val,
      required: !!valDef['*'],
      error: '',
      type: valDef.type,
      sensitive: valDef.sensitive,
    });
  }
};



// WEBPACK FOOTER //
// ./src/utils/forms.js